module.exports = __webpack_public_path__ + "static/media/view11_front.cfb82289.png";